import {createLoaderWorker} from '@loaders.gl/loader-utils';
import {DracoLoader} from '../index';

createLoaderWorker(DracoLoader);
